import tmhRequest from '@/config/tmhRequest'

export default {
    searchPremiumMemberReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/premiummemberreport/searchpremiummemberreportcount',
            method: 'post',
            data: data,
        })
    },
    searchPremiumMemberReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/premiummemberreport/searchpremiummemberreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportPremiumMemberReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/premiummemberreport/exportpremiummemberreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
    multiExportPaymentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/multiexportpaymentreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
    repairPaymentReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/paymentreport/repairpaymentreport',
            method: 'get',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/premiummemberreport.js